import styled, { css } from 'styled-components';

interface StyledButtonProps {
  type?: string;
  disabled?: boolean;
}
export const StyledButton = styled.button<StyledButtonProps>`
  border: 0;
  cursor: pointer;
  background: ${({ theme }) => {
    if (!theme.useBrandColors) return '#FF422B';
    return !theme.isUK2 && theme.useBrandColors ? theme.colors.background : theme.colors.primary;
  }};

  border-radius: 3px;
  color: white;
  font-size: 14px;
  opacity: ${({ disabled }) => (disabled ? '0.33' : 1)};

  ${({ type }) => {
    if (type == 'gradient') {
      return css`
        border: 0;
        cursor: pointer;
        background: ${({ theme }) => theme.colors.background};
        color: white;
        height: 40px;
        padding: 10px;
        border-radius: 2px;
        gap: 4px;
      `;
    }
  }}
`;
